module.exports = __webpack_public_path__ + "img/us.01b0f0cc.svg";